import { create, filter, findAll, findOne, getOne, resetSave, update } from "@/store/Crud/functions/actions";
export const setSelectedEducationClass = (store, selectedEducationClass) => {
    store.commit("SELECT_EDUCTION_CLASS", selectedEducationClass);
};
export default {
    create,
    filter,
    findOne,
    update,
    findAll,
    getOne,
    resetSave,
    setSelectedEducationClass,
};
